import {
  BankConfig,
  BankConfigFields,
} from '../../enterprise/BankAccountsSettings/BankAccountsSettings.types';

const bankConfigFieldsDefault: BankConfigFields = {
  agreementNumber: {},
  agreementDescription: {},
  agreementSpecies: {},
  agreementInstantRegister: {},
  agreementStation: {},
  agreementBankOurNumber: {},
  titleFineRateValue: { fractions: 2 },
  titleDiscountCode3: { visible: false },
  titleDiscountDate3: { visible: false },
  titleDiscountRateValue3: { visible: false },
};

export const bankConfig: BankConfig = {
  '077': {
    name: 'Banco Inter',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { visible: true },
      agreementInstantRegister: { disabled: true, initialValue: 1 },
      agreementWebServiceType: {
        options: ['v1', 'v2', 'v2.2', 'v3', 'SHOPFACIL', 'NORMAL'],
      },
      agreementRemittanceNumber: {},
      agreementContractNumber: {},
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: { options: ['112'] },
      bankBranch: { maxLength: 4, required: true, visible: true },
      branchVerificationNumber: { maxLength: 2, required: true, visible: true },
      number: { maxLength: 8, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      agreementBankOurNumber: { disabled: true, initialValue: 1 },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado a conta corrente sem o DV.',
      },
      certificate: { required: true },
      agreementHybridEmission: { visible: true },
    },
  },
  '001': {
    name: 'Banco do Brasil',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { visible: true },
      agreementRemittanceNumber: {},
      agreementWebServiceType: {
        options: ['v1', 'v2', 'v2.2', 'v3', 'SHOPFACIL', 'NORMAL'],
      },
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: { options: ['17', '18'], maxLength: 2 },
      bankBranch: { maxLength: 4, required: true, visible: true },
      branchVerificationNumber: { maxLength: 1, required: true, visible: true },
      number: { maxLength: 8, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado a conta corrente sem o DV.',
      },
      agreementHybridEmission: { visible: true },
      titleCodeReferente: { visible: true, maxLength: 50 },
    },
  },
  '246': {
    name: 'Banco ABC',
    fields: {
      ...bankConfigFieldsDefault,
      agreementWalletCode: {},
      agreementContractNumber: {},
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: {
        options: ['100', '121', '101', '180', '108', '110', '112', '144'],
      },
      bankBranch: { maxLength: 5, required: true, visible: true },
      branchVerificationNumber: { maxLength: 2, required: true, visible: true },
      number: { maxLength: 7, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o código do beneficiário e é composto por até 7 dígitos.',
      },
      codeCompanyBank: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o Acessório Escritural (Verificar informação com o Banco).',
      },
      agreementRemittanceNumber: {},
      titleFineRateValue: { fractions: 4 },
    },
  },
  '336': {
    name: 'Banco C6',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { visible: true },
      agreementCnabPattern: { options: ['400'] },
      agreementWallet: {
        options: ['10', '20', '30', '40'],
      },
      bankBranch: { maxLength: 5, required: true, visible: true },
      branchVerificationNumber: { required: false, visible: false },
      number: { maxLength: 12, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Caso o C6 não tenha especificado um valor, é comum que o mesmo seja idêntico ao código empresa.',
      },
      codeCompanyBank: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o Acessório Escritural (Verificar informação com o Banco).',
      },
      agreementRemittanceNumber: {},
      titleFineRateValue: { fractions: 0 },
    },
  },
  '237': {
    name: 'Bradesco',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { initialValue: 0, visible: true, disabled: true },
      agreementRemittanceDensity: { options: ['1600', '6250'] },
      agreementWebServiceType: {
        options: ['v1', 'v2', 'v2.2', 'v3', 'SHOPFACIL', 'NORMAL'],
      },
      agreementInstantRegister: { visible: true },
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: {
        options: ['02', '04', '06', '09'],
      },
      agreementWsConsult: { visible: true, disabled: true, initialValue: 1 },
      bankBranch: { maxLength: 4, required: true, visible: true },
      branchVerificationNumber: { maxLength: 2, required: true, visible: true },
      number: { maxLength: 7, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o número da conta sem o DV.',
      },
      codeCompanyBank: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o Acessório Escritural (Verificar informação com o Banco).',
      },
      agreementRemittanceNumber: {},
      certificate: { required: true },
    },
  },
  '341': {
    name: 'Itaú Unibanco',
    fields: {
      ...bankConfigFieldsDefault,
      agreementWebServiceType: {
        options: ['v1', 'v2', 'v2.2', 'v3', 'SHOPFACIL', 'NORMAL'],
      },
      agreementNumber: { required: true },
      agreementInstantRegister: { visible: true },
      agreementWsConsult: { visible: true, disabled: true, initialValue: 1 },
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: { options: ['109', '104', '175'] },
      bankBranch: { maxLength: 4, required: true, visible: true },
      branchVerificationNumber: { required: false, visible: true },
      number: { maxLength: 5, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o número da conta sem o DV.',
      },
      titleAcceptance: { initialValue: 0, disabled: true },
      agreementRemittanceNumber: {},
      agreementHybridEmission: { visible: true },
      certificate: { required: true },
    },
  },
  '033': {
    name: 'Santander',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { visible: true },
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: { options: ['RCR', 'CSR'] },
      bankBranch: { maxLength: 4, required: true, visible: true },
      branchVerificationNumber: { maxLength: 2, required: true, visible: true },
      number: { maxLength: 12, required: true, visible: true },
      verificationNumber: { maxLength: 2, required: true, visible: true },
      agreementWebServiceType: {
        options: ['v1', 'v2'],
      },
      beneficiaryCode: {
        required: true,
        helpMessage: 'Neste campo pode ser informado o código do beneficiário.',
      },
      agreementRemittanceNumber: {},
      agreementHybridEmission: { visible: true },
      certificate: { required: true },
    },
  },
  '041': {
    name: 'Banrisul',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { visible: true },
      agreementLayoutFileVersion: { options: ['001'] },
      agreementWalletCode: {},
      agreementContractNumber: {},
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: { options: ['1', '2'] },
      bankBranch: { maxLength: 4, required: true, visible: true },
      branchVerificationNumber: { visible: false, required: false },
      number: { maxLength: 9, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Código do Convênio no Banco (número fornecido pelo Banco). Trata-se do código adotado pelo Banco para identificar o contrato. ' +
          'É composto por: Número da agência (4 dígitos), código do beneficiário (7 dígitos) e número de controle (2 dígitos).',
      },
      agreementRemittanceNumber: {},
      certificate: { required: true },
    },
  },
  '422': {
    name: 'Safra',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { visible: true },
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: { options: ['1', '2'] },
      bankBranch: { maxLength: 5, required: true, visible: true },
      branchVerificationNumber: { visible: false, required: false },
      number: { maxLength: 7, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o número da conta com o DV.',
      },
      agreementRemittanceNumber: {},
    },
  },
  '707': {
    name: 'Daycoval',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { visible: true },
      agreementLayoutFileVersion: { options: ['001', '002'] },
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: { options: [] },
      bankBranch: { maxLength: 4, required: true, visible: true },
      branchVerificationNumber: { maxLength: 2, required: true, visible: true },
      number: { maxLength: 7, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o número da conta sem o DV.',
      },
      codeCompanyBank: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o Acessório Escritural (Verificar informação com o Banco).',
      },
      agreementRemittanceNumber: {},
    },
  },
  '748': {
    name: 'Sicredi',
    fields: {
      ...bankConfigFieldsDefault,
      agreementNumber: { required: true },
      agreementRestartDaily: { visible: true },
      agreementCnabPattern: { options: ['240', '400'], required: true },
      agreementWallet: { options: ['1'] },
      agreementWebServiceType: {
        options: ['v1', 'v2', 'v2.2', 'v3', 'SHOPFACIL', 'NORMAL'],
      },
      agreementWsConsult: { visible: true, disabled: true, initialValue: 1 },
      bankBranch: {
        required: true,
        visible: true,
        helpMessage:
          'Para o Sicredi terá que ser informado a (Agência + Posto)',
      },
      branchVerificationNumber: { required: false, visible: false },
      number: { required: true, visible: true },
      verificationNumber: { required: true, visible: true },
      agreementRemittanceNumber: { required: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Caso o Sicredi não tenha especificado um valor, é comum que o mesmo seja o número da conta sem o DV.',
      },
      titleDiscountCode: {
        options: ['0', '1', '2'],
      },
      agreementHybridEmission: { visible: true },
    },
  },
  '756': {
    name: 'Siccob',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { visible: true },
      agreementWalletCode: { maxLength: 1 },
      agreementContractNumber: {},
      agreementCnabPattern: { options: ['240', '400'], required: true },
      agreementWebServiceType: {
        options: ['v1', 'v2', 'v2.2', 'v3', 'SHOPFACIL', 'NORMAL'],
      },
      agreementWallet: { options: ['1', '3'], maxLength: 1, required: true },
      agreementWsConsult: { visible: true, disabled: true, initialValue: 1 },
      bankBranch: { maxLength: 4, required: true, visible: true },
      branchVerificationNumber: { maxLength: 2, required: true, visible: true },
      number: { maxLength: 8, required: true, visible: true },
      verificationNumber: { maxLength: 2, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o código do beneficiário com o seu DV.',
      },
      agreementNumber: {
        helpMessage: 'Informar o mesmo valor do código do beneficiário',
      },
      agreementRemittanceNumber: {},
      agreementHybridEmission: { visible: true },
      certificate: { required: true },
    },
  },
  '104': {
    name: 'Caixa Econômica Federal',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { visible: false },
      agreementLayoutFileVersion: { options: ['107', '101'] },
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: {
        options: ['SR', 'CR', 'CS', 'RG', '01', '11', '14', '24'],
      },
      agreementWsConsult: { visible: true, disabled: true, initialValue: 1 },
      bankBranch: { maxLength: 4, required: true, visible: true },
      branchVerificationNumber: { required: false, visible: true },
      number: { maxLength: 15, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o código do beneficiário sem o DV (O DV será calculado pela aplicação).',
      },
      agreementRemittanceNumber: {},
      titleDiscountCode3: { visible: true },
      titleDiscountDate3: { visible: true },
      titleDiscountRateValue3: { visible: true },
      agreementHybridEmission: { visible: true },
    },
  },
  '133': {
    name: 'Cresol',
    fields: {
      ...bankConfigFieldsDefault,
      agreementRestartDaily: { visible: true },
      agreementLayoutFileVersion: { options: ['237', '001'] },
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: { options: ['09'] },
      bankBranch: { maxLength: 4, required: true, visible: true },
      branchVerificationNumber: {
        maxLength: 1,
        required: false,
        visible: true,
      },
      number: { maxLength: 7, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado a conta corrente sem o DV.',
      },
      codeCompanyBank: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado o Acessório Escritural (Verificar informação com o Banco).',
      },
      agreementRemittanceNumber: {},
    },
  },
  '004': {
    name: 'Banco do Nordeste',
    fields: {
      ...bankConfigFieldsDefault,
      agreementInstantRegister: { initialValue: 0, disabled: true },
      agreementRestartDaily: { visible: true },
      agreementCnabPattern: { options: ['240', '400'] },
      agreementWallet: { options: [] },
      bankBranch: { maxLength: 4, required: true, visible: true },
      number: { maxLength: 7, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      beneficiaryCode: {
        required: true,
        helpMessage:
          'Neste campo pode ser informado a conta corrente sem o DV.',
      },
      codeCompanyBank: {
        required: false,
        helpMessage:
          'Neste campo pode ser informado o Acessório Escritural (Verificar informação com o Banco).',
      },
      agreementRemittanceNumber: {},
    },
  },
  '085': {
    name: 'Ailos',
    fields: {
      ...bankConfigFieldsDefault,
      agreementDescription: { required: true },
      agreementNumber: { maxLength: 20 },
      agreementWallet: { options: ['1', '2', '3', '4', '5'] },
      agreementCnabPattern: { options: ['240'] },
      agreementWebServiceType: {
        options: ['v1'],
      },
      agreementSandboxEnvironment: {
        visible: true,
        required: true,
        initialValue: 1,
      },
      bankBranch: { maxLength: 5, required: true, visible: true },
      branchVerificationNumber: { maxLength: 1, required: true, visible: true },
      number: { maxLength: 12, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      agreementInstantRegister: { visible: true },
      agreementRestartDaily: { visible: true },
      beneficiaryCode: {
        helpMessage:
          'Neste campo pode ser informado o número da conta mais o DV.',
      },
      codeCompanyBank: {
        helpMessage:
          'Neste campo deve ser inserido o valor de código de empresa repassado pelo banco.',
      },
      agreementAilosPassword: {
        visible: true,
      },
    },
  },
  '089': {
    name: 'CREDISAN',
    fields: {
      ...bankConfigFieldsDefault,
      agreementDescription: { required: true },
      agreementNumber: { maxLength: 20 },
      agreementWallet: { options: ['1', '2', '3', '4', '5'] },
      agreementCnabPattern: { options: ['240'] },
      bankBranch: { maxLength: 5, required: true, visible: true },
      branchVerificationNumber: { maxLength: 1, required: true, visible: true },
      number: { maxLength: 12, required: true, visible: true },
      verificationNumber: { maxLength: 1, required: true, visible: true },
      agreementRestartDaily: { visible: true },
      beneficiaryCode: {
        helpMessage:
          'Neste campo pode ser informado o número da conta mais o DV.',
      },
      codeCompanyBank: {
        helpMessage:
          'Neste campo deve ser inserido o valor de código de empresa repassado pelo banco.',
      },
    },
  },
  // add more banks
};
